<template>
  <div class="how-it-works" >
    <div id="headerHowItWorksPopover" class="how-it-works__wrapper" >
      <VLazyImage
        :src="icons.info"
        alt="Ícone com a letra i em um círculo"
        class="how-it-works__icon d-none d-lg-inline"
        width="22"
        height="22"
      />

      <span class="d-none d-lg-inline">
        Ajuda
      </span>

      <VLazyImage
        :src="icons.lifebuoy"
        alt="Help Icon"
        class="how-it-works__icon d-inline d-lg-none"
      />

      <span>
        <strong class="how-it-works__text d-inline d-lg-none">Ajuda</strong>
      </span>
      <how-it-works-info-viewer target-id="headerHowItWorksPopover"></how-it-works-info-viewer>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@quero/zilla-core/src/utils/functions.scss';
  @import '@quero/zilla-core/src/utils/variables.scss';

  .how-it-works {
    cursor: help;
    display: flex;
  }

  .how-it-works__wrapper {
    align-items: center;
    color: var(--color-neutral-gray-darker);
    display: flex;
    flex-direction: column;
    font-size: rem(14);
    justify-content: center;

    @media (min-width: $screen-sm-min) {
      border: 0;
      flex-direction: row;
    }
  }

  .how-it-works__icon {
    @media (min-width: $screen-sm-min) {
      margin-right: $space-s;
    }
  }

  .how-it-works__text {
    font-size: rem(12);

    @media (min-width: $screen-lg-min) {
      font-size: rem(15);
    }
  }

  .how-it-works__popover-content {
    color: var(--color-neutral-gray-clear);
    font-size: rem(15);
    padding: $space-s $space-xs;
    text-align: center;
  }
</style>

<script>
  import VLazyImage from "v-lazy-image";
  import HowItWorksInfoViewer from '~/components/header/how-it-works-info-viewer'

  import info from '~/assets/images/icons/i-info.svg';
  import lifebuoy from '~/assets/images/icons/i-lifebuoy.svg';

  export default {
    data() {
      return {
        icons: {
          info,
          lifebuoy,
        },
      };
    },
    components: {
      HowItWorksInfoViewer,
      VLazyImage,
    },
  };
</script>
